import { render, staticRenderFns } from "./UserValidSettingsTable.vue?vue&type=template&id=6a40535b&"
import script from "./UserValidSettingsTable.vue?vue&type=script&lang=js&"
export * from "./UserValidSettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports